export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

const APPROVED_AUTH_ORIGIN = "https://mizanoapp.com";

/**
 * OAuth only accepts approved callback domains. Temporary Manus preview hosts are
 * intentionally not registered, so authenticate through the published Mizano
 * domain and return there when a preview is being viewed.
 */
export const getLoginOrigin = (currentOrigin = window.location.origin) => {
  const hostname = new URL(currentOrigin).hostname;
  return hostname.endsWith(".manus.computer")
    ? APPROVED_AUTH_ORIGIN
    : currentOrigin;
};

// Generate the login URL at runtime using an OAuth-approved callback origin.
export const getLoginUrl = (workspace: "individual" | "business" = "individual") => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  const redirectUri = `${getLoginOrigin()}/api/oauth/callback`;
  const state = btoa(JSON.stringify({ redirectUri, workspace }));

  const url = new URL(`${oauthPortalUrl}/app-auth`);
  url.searchParams.set("appId", appId);
  url.searchParams.set("redirectUri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("type", "signIn");

  return url.toString();
};
